import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import jquerySimpleColor from "jquery-simple-color/jquery.simple-color.js";
import ScrollReveal from 'scrollreveal';


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          animateOut: 'fadeOut',
          center: true,
          navText: ['<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel').owlCarousel({
          items: 1,
          margin: 16,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_ノーマル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel.is-normal').owlCarousel({
          items: 1,
          margin: 8,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_レイヤー
      owls.imagesLoaded(function () {
        $('.c-main-visual-layer__carousel').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 8,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-prev-white.png" />', '<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-next-white.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 2,
              center: false
            },
            950: {
              items: 3,
            }
          }
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.c-relation-slider__slider').owlCarousel({
          margin: 36,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 2,
              center: false
            },
            950: {
              items: 3,
            }
          }
        });
      });
      owls.imagesLoaded(function () {
        $('.c-gallery__mainslider').owlCarousel({
          items: 1,
          dots: true,
          loop: true,
          nav: true,
          margin: 0,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/artceramic-html/dist/assets/images/icon-slider-next.svg" />'],

        });
      });


    }


    function jsColorPciker() {
      $('.simple_color').simpleColor({
        boxWidth: '120px',
        boxHeight: '40px',
        cellWidth: 28,
        cellHeight: 28,
        columns: 6,
        colors: [
          "E60012",
          "F39800",
          "FFF100",
          "8FC31F",
          "009944",
          "009E96",
          "00A0E9",
          "0068B7",
          "1D2088",
          "920783",
          "E4007F",
          "E5004F",
          "FFFFFF",
          "EFEFEF",
          "C9CACA",
          "9FA0A0",
          "727171",
          "3E3A39",
          "40220F",
          "6A3906",
          "956134",
          "B28247",
          "C9A063",
          "D3B78F"

        ],
        callback: function (hex, element) {
          alert("color picked! " + hex + " for input #" + element.attr('class'));
        }
      });
    }

    function scrollReveal() {
      // スクロールリーバル
      window.sr = new ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }

        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      sr.reveal(".slideto-left", {
        scale: 1,
        duration: 800,
        distance: '50%',
        opacity: 0.5,
        origin: 'right',
        delay: 300,
        easing: 'ease-out'
      }, 100);

      sr.reveal(".slideto-left-delay", {
        scale: 1,
        duration: 800,
        distance: '100%',
        opacity: 0.5,
        origin: 'right',
        delay: 600,
        easing: 'ease-out'
      }, 100);


      sr.reveal(".fadein-bottom", {
        scale: 1,
        duration: 1000,
        distance: '50%',
        opacity: 0,
        origin: 'bottom',
        delay: 800,
        easing: 'ease'
      }, 100);

      sr.reveal(".fadein", {
        scale: 1,
        duration: 2000,
        opacity: 0,
        delay: 500,
        easing: 'ease'
      }, 100);


      var blocks01 = $(".js-reveal-chain");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, delay: 400, duration: 600, distance: '10px'}, 100);
        sr.reveal(item.children[1], {delay: 500, scale: 1, duration: 600, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[2], {delay: 600, scale: 1, duration: 600, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[3], {delay: 700, scale: 1, duration: 600, distance: '10px', easing: 'ease'}, 100);
        sr.reveal(item.children[4], {delay: 800, scale: 1, duration: 600, distance: '10px', easing: 'ease'}, 10);
        sr.reveal(item.children[5], {delay: 900, scale: 1, duration: 600, distance: '10px', easing: 'ease'}, 100);
      });
    }

    function buttonwrap() {
      $(".c-button").wrapInner("<span></span>");
    }


    function headerFixed() {
      var headerOffset = $(".l-header-minimal__content").offset().top;
      var mainOffset = $(".l-main").offset().top;
      $(window).on('scroll', function (event) {
        var scrollTop = $(window).scrollTop();
        var windowWidth = $("body").innerWidth();
        if (windowWidth > 949) {
          if (scrollTop >= headerOffset) {
            $("body").addClass("is-scrolling");
          } else {
            $("body").removeClass("is-scrolling");
          }
        } else {
          if (scrollTop >= mainOffset) {
            $("body").addClass("is-scrolling");
          } else {
            $("body").removeClass("is-scrolling");
          }
        }

      });
    }

    function headingAccent() {
      var headings = $(".js-headred");
      headings.each(function () {
        var ini = $(this).html().slice(0, 1);
        var texts = $(this).html();
        var blackTexts = texts.slice(1);
        var replaceText = "<span class='is-accent'>" + ini + "</span>" + blackTexts;
        $(this).html(replaceText);
      });
    }

    $(function () {
      buttonwrap();
      menuSlide();
      owlCarousel();
      headerFixed();
      headingAccent();
      jsColorPciker();
      scrollReveal();
    });
  }
}

window.GApp = new App();
